const sectorValues = [
  { value: 'Public', label: 'Public' },
  { value: 'Private', label: 'Private' },
  { value: 'None', label: 'Unemployed' }
];

export default sectorValues;
